var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#323232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5106 17.4223C24.8256 16.9913 25 16.4632 25 15.9137C25 15.042 24.5294 14.2169 23.7719 13.7567C23.5769 13.6383 23.3548 13.5759 23.1287 13.5762H18.6325L18.745 11.19C18.7713 10.6134 18.5744 10.0659 18.1919 9.64848C18.0042 9.44273 17.7777 9.27903 17.5265 9.1675C17.2752 9.05596 17.0046 8.99896 16.7312 9.00001C15.7562 9.00001 14.8938 9.67954 14.635 10.6522L13.0244 16.6903H13.0187V25H21.8744C22.0469 25 22.2156 24.9651 22.3712 24.8952C23.2637 24.501 23.8394 23.5982 23.8394 22.5964C23.8394 22.3518 23.8056 22.111 23.7381 21.8781C24.0531 21.447 24.2275 20.9189 24.2275 20.3695C24.2275 20.1249 24.1938 19.8841 24.1263 19.6511C24.4413 19.2201 24.6156 18.692 24.6156 18.1426C24.6119 17.898 24.5781 17.6553 24.5106 17.4223ZM10 17.3116V24.3787C10 24.7224 10.2681 25 10.6 25H11.8187V16.6903H10.6C10.2681 16.6903 10 16.968 10 17.3116Z",
    fill: "#FF9A2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#FF9A2E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodNews);
export default __webpack_public_path__ + "static/media/good-news.7a61e09e19a4369a83b2af63b527f9cc.svg";
export { ForwardRef as ReactComponent };